import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08f5e570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-mail-dialog" }
const _hoisted_2 = { class: "field-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label required" }, "日期", -1))
const _hoisted_4 = {
  key: 0,
  class: "field-error"
}
const _hoisted_5 = { class: "field-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label required" }, "邮件类型", -1))
const _hoisted_7 = {
  key: 0,
  class: "field-error"
}
const _hoisted_8 = { class: "field-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label required" }, "邮箱地址", -1))
const _hoisted_10 = {
  key: 0,
  class: "field-error"
}

import { reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import {
  pickClosestLDate,
  queryForecastLDateOptions,
  queryForecastLastMailReceiver,
  sendForecastEmail,
} from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendMailDialog',
  props: {
    visible: { type: Boolean },
    defaultLDate: null
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  /** 弹窗打开时预填日期（通常取列表当前筛选） */
  defaultLDate?: string;
}





const EMAIL_TYPE_BEFORE_CLOSE = 'BEFORE_CLOSE';
const EMAIL_TYPE_AFTER_CLOSE = 'AFTER_CLOSE';

const loading = ref(false);
const submitting = ref(false);
const lDateFetching = ref(false);
const lDateOptions = ref<{ value: string; label: string }[]>([]);
const emailTypeOptions = [
  { value: EMAIL_TYPE_BEFORE_CLOSE, label: '关账前' },
  { value: EMAIL_TYPE_AFTER_CLOSE, label: '关账后' },
];
const mailReceivers = ref('');
const lDateInvalid = ref(false);
const emailTypeInvalid = ref(false);
const receiverInvalid = ref(false);

const form = reactive({
  lDate: undefined as string | undefined,
  emailType: EMAIL_TYPE_BEFORE_CLOSE as string,
});

function normalizeReceivers(raw?: string | null) {
  const text = (raw ?? '').trim();
  if (!text) return '';
  return text
    .split(/[\n,;，；]+/)
    .map((item) => item.trim().replace(/^['"]+|['"]+$/g, ''))
    .filter(Boolean)
    .join('\n');
}

function formatReceiverForApi(raw: string) {
  return raw
    .split(/[\n,;，；]+/)
    .map((item) => item.trim().replace(/^['"]+|['"]+$/g, ''))
    .filter(Boolean)
    .join(';');
}

async function loadLDateOptions() {
  lDateFetching.value = true;
  try {
    const dates = await queryForecastLDateOptions();
    lDateOptions.value = dates.map((d) => ({ value: d, label: d }));
    const preferred = (props.defaultLDate || '').trim();
    if (preferred && dates.includes(preferred)) {
      form.lDate = preferred;
    } else {
      form.lDate = pickClosestLDate(dates);
    }
  } catch (error) {
    lDateOptions.value = [];
    message.error(error instanceof Error ? error.message : '查询日期选项失败');
  } finally {
    lDateFetching.value = false;
  }
}

async function loadLastReceiver(emailType: string) {
  try {
    const data = await queryForecastLastMailReceiver(emailType);
    const receiver = (data?.receiver ?? '').trim();
    mailReceivers.value = receiver ? normalizeReceivers(receiver) : '';
  } catch (error) {
    mailReceivers.value = '';
    message.error(error instanceof Error ? error.message : '查询最近收件人失败');
  }
}

async function handleEmailTypeChange(value: string) {
  emailTypeInvalid.value = false;
  form.emailType = value || EMAIL_TYPE_BEFORE_CLOSE;
  loading.value = true;
  try {
    await loadLastReceiver(form.emailType);
  } finally {
    loading.value = false;
  }
}

watch(
  () => props.visible,
  async (open) => {
    if (!open) return;
    form.lDate = undefined;
    form.emailType = EMAIL_TYPE_BEFORE_CLOSE;
    mailReceivers.value = '';
    lDateInvalid.value = false;
    emailTypeInvalid.value = false;
    receiverInvalid.value = false;
    submitting.value = false;
    loading.value = true;
    try {
      await Promise.all([loadLDateOptions(), loadLastReceiver(form.emailType)]);
    } finally {
      loading.value = false;
    }
  },
);

function handleCancel() {
  if (submitting.value) return;
  emit('update:visible', false);
}

async function handleConfirm() {
  if (submitting.value) return;
  const lDate = (form.lDate || '').trim();
  if (!lDate) {
    lDateInvalid.value = true;
    message.error('日期 必填');
    return;
  }
  lDateInvalid.value = false;

  const emailType = (form.emailType || '').trim();
  if (!emailType) {
    emailTypeInvalid.value = true;
    message.error('邮件类型 必填');
    return;
  }
  emailTypeInvalid.value = false;

  const receiver = formatReceiverForApi(mailReceivers.value);
  if (!receiver) {
    receiverInvalid.value = true;
    message.error('邮箱地址 必填');
    return;
  }
  receiverInvalid.value = false;

  submitting.value = true;
  try {
    await sendForecastEmail({ lDate, emailType, receiver });
    message.success('发送成功');
    emit('update:visible', false);
  } catch (error) {
    message.error(error instanceof Error ? error.message : '发送邮件失败');
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "发送邮件",
    width: 640,
    "confirm-loading": submitting.value,
    "mask-closable": false,
    "destroy-on-close": "",
    "ok-text": "确认发送",
    "cancel-text": "取消",
    onOk: handleConfirm,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_a_select, {
                value: form.lDate,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.lDate) = $event)),
                "allow-clear": "",
                placeholder: "请选择日期",
                options: lDateOptions.value,
                loading: lDateFetching.value,
                class: _normalizeClass({ 'field-invalid': lDateInvalid.value }),
                style: {"width":"100%"},
                onChange: _cache[1] || (_cache[1] = ($event: any) => (lDateInvalid.value = false))
              }, null, 8, ["value", "options", "loading", "class"]),
              (lDateInvalid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "必填"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_a_select, {
                value: form.emailType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.emailType) = $event)),
                options: emailTypeOptions,
                class: _normalizeClass({ 'field-invalid': emailTypeInvalid.value }),
                style: {"width":"100%"},
                onChange: handleEmailTypeChange
              }, null, 8, ["value", "class"]),
              (emailTypeInvalid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "必填"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_textarea, {
                value: mailReceivers.value,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((mailReceivers).value = $event)),
                class: _normalizeClass(["mail-receivers-input", { 'field-invalid': receiverInvalid.value }]),
                rows: 5,
                placeholder: "请输入邮箱地址，多个邮箱请换行填写",
                onInput: _cache[4] || (_cache[4] = ($event: any) => (receiverInvalid.value = false))
              }, null, 8, ["value", "class"]),
              (receiverInvalid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "必填"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})